import { z } from 'zod';

/** Month selector for the plan-vs-real endpoint: YYYY-MM, month in 01..12. */
export const PlanVsRealQuerySchema = z.object({
  month: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'month must be YYYY-MM'),
});

export type PlanVsRealQuery = z.infer<typeof PlanVsRealQuerySchema>;
